<template>
  <div :class="classes">
      <pt-page-title title="咨询商品预约工单" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey"></pt-page-title>
      <pt-page-factor-filter :labels="orderTabLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
          <el-button type="primary" @click="filter()">筛选</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          <el-button type="primary" @click="toEduce">导出</el-button>
          <el-button type="primary" @click="toHistory">导出历史</el-button>
      </pt-page-factor-filter>
      <pt-work-order-table :tableLabels="tableLabels" :params-data="paramsData" :isSearch="isSearch" ref="table" :isFromRouter="isFromRouter">
          <el-table-column label="预约状态">
                <template slot-scope="scope">
                  {{scope.row.order_status}}
                </template>
            </el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
              </template>
          </el-table-column>
      </pt-work-order-table>
  </div>
</template>

<script>
import ptWorkOrderTable from '../pt-work-order-table/withData'
import { orderTabLabels, tableLabels } from '../work-order'
import { emptyObject } from '@/utils/lifebankUtils'

// 组件class前缀
const prefixCls = 'pt-consulting-subscribe-order'

export default {
  name: 'pt-consulting-subscribe-order',
  props: {
    newsCategories: {
      type: Array,
      default: function () {
        return []
      }
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    tableParams: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptWorkOrderTable
  },
  data () {
    return {
      params: {},
      orderTabLabels: orderTabLabels,
      tableLabels: tableLabels,
      paramsData: this.tableParams,
      isSearch: '',
      searchKey: '',
      isFromRouter: false
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.isFromRouter = false
      this.paramsData.searchKey = val
      // this.isSearch = val
    },
    emptySearch (val) {
      this.$delete(this.searchKey, 'searchKey')
    },
    toEduce () {
      this.$refs.table.toEduce()
    },
    cleanParams () {
      emptyObject(this.params)
      this.filter()
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
      }
      if (!isFromRouter) {
        this.searchKey = null
        if (this.params.searchKey) {
          this.$delete(this.params, 'searchKey')
        }
        this.$refs.filter.getAddRouter(this.params)
      }
      this.paramsData = JSON.parse(JSON.stringify(this.params))
      this.paramsData = { ...this.params.publishDate, ...this.params }
    },
    toDetail (val) {
      this.$router.push('/consulting-subscribe-order/work-order-detail/' + val.id)
    },
    toHistory () {
      this.$router.push('/consulting-subscribe-order/work-order-history')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
